<template>
  <div>
    <v-autocomplete
        ref="input"
        v-model="data"
        :label="label"
        :loading="loading"
        :items="items"
        v-on="$listeners"
        :rules="rules"
        :item-text="itemText"
        :item-value="itemValue"
        :search-input.sync="searchText"
        :solo="solo"
        :dense="dense"
        :outlined="outlined"
        :clearable="clearable"
        :multiple="multiple"
        :append-icon="appendIcon"
        :readonly="readonly"
        :disabled="disabled"
        :placeholder="placeholder"
        @keydown="loadItems(searchText)"
        :persistent-placeholder="placeholder"
        no-filter
        hide-details
        hide-no-data
        autocomplete="nope"
    >
      <template #item="{item, on, attrs}">
        <v-list-item v-on="on" v-bind="attrs">
          <v-list-item-content>
            <v-list-item-title>
              {{ item.fullname }}
              <customer-status-badge v-if="isInactive(item)" :status="item.status" class="ml-2" />
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ item.evcoId }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template #selection="{item}" v-if="!selectionWithNoExtra">
        <div v-if="selectionOneLine">
          {{ item.fullname }} <span class="subtitle-1">({{ item.evcoId }})</span>
          <customer-status-badge v-if="isInactive(item)" :status="item.status" class="ml-2" />
        </div>
        <v-list-item v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.fullname }}
              <customer-status-badge v-if="isInactive(item)" :status="item.status" class="ml-2" />
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ item.evcoId }} <b>({{ item.organization?.name ?? "Pas d'organisation" }})</b>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template #selection="{item}" v-else>
        {{ item.fullname }}
      </template>

    </v-autocomplete>
  </div>
</template>

<script>

import CustomerRepository from "@repository/CustomerRepository";
import CustomerStatusBadge from "@/components/blocks/CustomerStatusBadge.vue";

export default {
  components: { CustomerStatusBadge },

  data(){
    return {
      loading: false,
      items: [],
      data: this.value,
      searchText: "",
      oldValue: this.value,
    }
  },

  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    value: String,
    type: String,
    clearable: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    multiple: Boolean,
    solo: Boolean,
    dense: Boolean,
    outlined: Boolean,
    selectionOneLine: Boolean,
    rules: Array,
    appendIcon: String,
    placeholder: String,
    label: String,
    organizationId: String,
    instanceId: String,
    selectionWithNoExtra: Boolean,
    itemText: {type: String, default: 'name'},
    itemValue: {type: String, default: 'id'},
  },

  watch: {
    searchText(val) {
      if(val) {
        this.loadItems(val)
      }
    },

    data(val) {
      this.$emit('input', val)
      this.oldValue = val
    },

    value(val) {
      this.data = val
      this.loadItems(val)
    },

    organizationId() {
      if(this.searchText) {
        this.searchText = ''
      } else {
        this.loadItems('')
      }
    }
  },

  mounted() {
    if(this.data) {
      this.loadItems(this.data)
    }
  },

  computed: {

  },

  methods: {
    loadItems(searchText) {
      this.loading = true
      CustomerRepository.search({
        searchText,
        offset: 0,
        limit: 30,
        sortBy: 'createdAt',
        sortOrder: 'desc',
        organizationId: this.organizationId,
      }, this.instanceId).then(result => {
        this.items = result.items.map(c => {
          let fullname = []
          if(c.firstname) {
            fullname.push(c.firstname)
          }
          if(c.lastname) {
            fullname.push(c.lastname)
          }
          if(fullname.length === 0) {
            if(c.email) {
              fullname.push(c.email)
            } else if(c.email) {
              fullname.push(c.phone)
            }
          }
          return {
            ...c,
            fullname: fullname.join(' '),
          }
        })
        this.loading = false
        if(this.items.find(c => c.id === this.oldValue)) {
          this.$nextTick(() => {
            this.data = this.oldValue
          })
        }
      }).catch(err => {
        this.notifyError(err)
      })
    },

    isInactive(item) {
      return !!item.status && item.status !== 'active'
    },

    focus() {
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="scss">

</style>
